import AuthApi from '@/api/AuthApi';

class AuthService {

	async signInAsync (...args: Parameters<typeof AuthApi.signIn>) {
		const { data } = await AuthApi.signIn(...args);
		return data;
	}

	async resetPasswordAsync (...args: Parameters<typeof AuthApi.resetPassword>) {
		const { data } = await AuthApi.resetPassword(...args);
		return data;
	}

	async checkLoginForSuiteAsync (...args: Parameters<typeof AuthApi.checkLoginForSuite>) {
		const { data } = await AuthApi.checkLoginForSuite(...args);
		return data;
	}

	async confirmPasswordAsync (...args: Parameters<typeof AuthApi.confirmPassword>) {
		const { data } = await AuthApi.confirmPassword(...args);
		return data;
	}

	async checkLoginAsync (...args: Parameters<typeof AuthApi.checkLogin>) {
		const { data } = await AuthApi.checkLogin(...args);
		return data;
	}

	async updateEmailFromSignupAsync (...args: Parameters<typeof AuthApi.updateEmailFromSignup>) {
		const { data } = await AuthApi.updateEmailFromSignup(...args);
		return data;
	}

	async updatePasswordAsync (...args: Parameters<typeof AuthApi.updatePassword>) {
		const { data } = await AuthApi.updatePassword(...args);
		return data;
	}

	async updateEmailAsync (...args: Parameters<typeof AuthApi.updateEmail>) {
		const { data } = await AuthApi.updateEmail(...args);
		return data;
	}

}

export default function useAuthService () {
	return new AuthService();
}
